/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RunInputs */

const cs_action_run = /** @type {(inputs: Action_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit`)
};

const en_action_run = /** @type {(inputs: Action_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

/**
* | output |
* | --- |
* | "Run" |
*
* @param {Action_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_run = /** @type {((inputs?: Action_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_run(inputs)
	return cs_action_run(inputs)
});